import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const networkSecurityFieldPack: FieldPack = {
  id: 'network-security',
  name: 'Security Posture',
  description: 'Encryption, exposure, IAM, and security group associations',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'encrypted',
      label: 'Encrypted at Rest',
      type: FieldType.BOOLEAN,
      tags: ['security', 'encryption'],
      priority: 90,
      sensitivity: 'internal',
    },
    {
      id: 'publicExposure',
      label: 'Public Exposure',
      type: FieldType.SELECT,
      tags: ['security', 'exposure'],
      priority: 95,
      options: [
        { value: 'none', label: 'None' },
        { value: 'restricted', label: 'Restricted' },
        { value: 'open', label: 'Open (0.0.0.0/0)' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'sgAssociations',
      label: 'Security Groups',
      type: FieldType.MULTI_SELECT,
      tags: ['security'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'iamRole',
      label: 'IAM Role',
      type: FieldType.TEXT,
      tags: ['security', 'identity'],
      priority: 75,
      sensitivity: 'internal',
    },
    {
      id: 'publiclyAccessible',
      label: 'Publicly Accessible',
      type: FieldType.BOOLEAN,
      tags: ['security', 'exposure'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'mfaEnabled',
      label: 'MFA Enabled',
      type: FieldType.BOOLEAN,
      tags: ['security', 'identity'],
      priority: 70,
      sensitivity: 'internal',
    },
  ],
};
